<div
  class="btn-group navbar-btn"
  dropdown
  [isAnimated]="true"
  [insideClick]="true"
>
  <button id="button" dropdownToggle type="button" class="btn btn-link p-0">
    <img
      *ngIf="userAvatar; else defaultAvatar"
      [src]="userAvatar"
      alt="avatar"
      class="dx-icon avatar"
    />
    <ng-template #defaultAvatar>
      <i
        class="dx-icon text-white"
        [ngClass]="!userAvatar && 'dx-icon-user'"
      ></i>
    </ng-template>
  </button>
  <div
    *dropdownMenu
    class="dropdown-menu p-3"
    aria-labelledby="button"
    role="menu"
    style="min-width: 250px"
  >
    <div class="d-flex align-items-center">
      <img
        *ngIf="profile?.profileAvatar; else defaultAvatarMenu"
        [src]="profile?.profileAvatar"
        alt="avatar"
        class="dx-icon avatar"
        width="20"
      />
      <ng-template #defaultAvatarMenu>
        <i
          class="dx-icon text-black"
          [ngClass]="!profile?.profileAvatar && 'dx-icon-user'"
        ></i>
      </ng-template>
      <span class="text-black mx-2">{{ profile?.fullName }}</span>
      <span class="badge badge-pill bg-secondary ms-2">{{
        profile?.defaultPositions
      }}</span>
    </div>
    <div class="border-top border-1 mt-2 pt-2 d-flex align-items-center">
      <i class="fa fa-building text-muted fs-4 me-2"></i>
      <span>{{ profile?.charityTitle }}</span>
    </div>
    <div class="mt-2 d-flex align-items-center">
      <i class="fa fa-phone text-muted fs-5 me-2"></i>
      <span>{{ profile?.mobileNumber }}</span>
    </div>
    <div class="mt-2 d-flex align-items-center">
      <i class="fa fa-hand-holding-hand text-muted fs-4 me-2"></i>
      <span>{{ profile?.defaultCooperationType }}</span>
    </div>
    <div class="border-top border-1 mt-2 pt-2">
      <a href="/profile/edit">
        <button class="btn btn-link text-decoration-none text-success ps-0">
          <i class="fa fa-pen fs-5 me-2"></i>
          <span>{{ "homePage.labels.edit" | translate }}</span>
        </button>
      </a>
      <!-- logoff buttton -->
      <br />
      <button
        class="btn btn-link text-decoration-none text-success ms-auto ps-0"
        (click)="logOff()"
      >
        <i class="fa fa-sign-out-alt fs-5 me-2"></i>
        <span>{{ "homePage.labels.logoff" | translate }}</span>
      </button>
    </div>
    <!-- Add more dropdown items here if needed -->
  </div>
</div>
